'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const UrlIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="UrlIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Hyperlink-2--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Hyperlink 2 Streamline Icon: https://streamlinehq.com</desc>
        <g>
          <path
            d="M14.8 12.56a2.25 2.25 0 0 0 3.27 0.1l4.45 -4.45a3.37 3.37 0 0 0 0 -4.76l-2 -2a3.37 3.37 0 0 0 -4.76 0l-4.42 4.48a2.24 2.24 0 0 0 0.1 3.26"
            fill="none"
            stroke="#3d517b"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="M9.2 11.44a2.26 2.26 0 0 0 -3.27 -0.1l-4.45 4.45a3.37 3.37 0 0 0 0 4.76l2 2a3.37 3.37 0 0 0 4.76 0l4.45 -4.45a2.25 2.25 0 0 0 -0.1 -3.27"
            fill="none"
            stroke="#3d517b"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
          <path
            d="m7.64 16.36 8.72 -8.72"
            fill="none"
            stroke="#3d517b"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

UrlIcon.propTypes = {
  sx: PropTypes.object
}
